<template>
  <div class="nav_warp b_color_2px">
    <div class="nav_box">
      <div class="logo_box"><img class="img" :src="publicPath + 'pclogo.png' + '?time=' + new Date().getTime()" /></div>

      <ul class="nav_list hover_color">
        <li>
          <router-link :class="$route.path == '/home' ? 'f_b_color_2px' : ''" to="/home">首页</router-link>
        </li>
        <li>
          <router-link :class="$route.path == '/job' ? 'f_b_color_2px' : ''" to="/job">退役求职</router-link>
        </li>
        <li>
          <router-link :class="$route.path == '/jobList' ? 'f_b_color_2px' : ''" to="/jobList">军属求职</router-link>
        </li>
        <li>
          <router-link :class="($route.path == '/news' || $route.path == '/newsDetails') ? 'f_b_color_2px' : ''" to="/news">新闻资讯</router-link>
        </li>
        <!-- <li>
          <router-link :class="$route.path == '/scActivity' ? 'f_b_color_2px' : ''" to="/scActivity">四川招聘会</router-link>
        </li> -->
        <li>
          <router-link :class="$route.path == '/aboutUs' ? 'f_b_color_2px' : ''" to="/aboutUs">关于我们</router-link>
        </li>
      </ul>
      <div style="text-align: right;">
        <div class="invite_btn bg_color" @click="enterCompany()">我要招聘<i class="el-icon-arrow-right"></i></div>
        <!-- <span>用户协议</span> -->
        <a class="licensebtn" :href="`/useragreement`" target="_blank"><span>用户协议</span></a>
      </div>
    </div>

  </div>
</template>
  
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      index: '/home',
      jobRouter: false,
      jobRouter2: false,
    }
  },
  created() {
    // let vm = this;
    // let fullurl = window.location.href
    // let url = fullurl.split("?")[0]
    // url = url.substring(url.length - 3)
    // if (this.$route.query.priority == undefined) {
    //   vm.id = fullurl.substring(fullurl.length - 1)
    // } else {
    //   vm.id = this.$route.query.priority;
    // }
    // setTimeout(() => {
    //   if (this.$route.path == '/job' || url == 'job') {
    //     this.checkNav(vm.id)
    //   }
    // }, 500)
  },
  mounted() {

  },
  computed: {
    ...mapState(['publicPath', 'platformInfo'])
  },
  watch: {
    '$route'(to, from) {
      this.changeTransition(to, from)
    }
  },
  methods: {
    changeTransition(to, from) {
      if (to.name == 'jobList') {
         document.getElementsByTagName('body')[0].style.setProperty('--test', '#1F7EC3');  //军属求职主题色
      } else {
        // this.jobRouter2 = false
        // this.jobRouter = false
        document.getElementsByTagName('body')[0].style.setProperty('--test', '#006934');  //81主题色
      }
    },
    checkNav(id) {
      if (id == 1) { // 退役求职
        this.jobRouter = true
        this.jobRouter2 = false
        this.$nextTick(() => {
          document.getElementsByTagName('body')[0].style.setProperty('--test', '#006934');  //退役求职主题色
        })
      } else if (id == 0) { //军属求职
        this.jobRouter2 = true
        this.jobRouter = false
        this.$nextTick(() => {
          document.getElementsByTagName('body')[0].style.setProperty('--test', '#1F7EC3');  //军属求职主题色
        })
      }
    },
    // 81联聘企业站
    enterCompany() {
      if (this.platformInfo.env == 'test') {
        window.open("https://test-bsp.81lianpin.com/mana/home");
      } else {
        window.open("https://bsp.81lianpin.com/mana/home");
      }
    }
  }
}
</script>
  
<style scoped>
.nav_warp {
  background: #fff;
}
.nav_box {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo_box {
  width: 214px;
  height: 67px;
}
.invite_btn {
  margin-top: 17px;
  margin-bottom: 5px;
  padding: 6px;
  font-size: 20px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.nav_list {
  width: 800px;
  height: 98px;
  display: flex;
  justify-content: space-around;
}
.nav_list li a {
  display: inline-block;
  height: 98px;
  line-height:  98px;
  font-size: 18px;
  padding: 0 15px;
  color: #888;
}
.licensebtn {
  color: #378be7;
  text-decoration: underline;
  /* display: inline-block; */
  margin-top: 12px;
  font-size: 14px;
}
</style>
  
  
  
  
  
  






// WEBPACK FOOTER //
// src/components/Nav2.vue